<template>
  <div class="uk-flex uk-flex-column uk-child-width-1-1 uk-red" :key="routerDetails">
    <div
      uk-dropdown="target: #inlineRulesBtn; mode: click; animation: uk-animation-slide-top-small; duration: 1300;"
      ref="instrucitonsModal"
      id="instrucitonsModal"
      class="general-instruction uk-border-rounded"
    >
      <BasicModal
        class="uk-padding-remove"
        :buttons="instructionsModalButtons"
        :actionStatus="saveInstructionsStatus"
        :showClose="true"
      >
        <GeneralInstructions class="uk-margin-bottom" v-if="teamID" />
      </BasicModal>
    </div>
    <div class="uk-flex uk-flex-between">
      <BreadCrumb
        :path="[
          {
            title: `${userData.display_name}`,
          },
          {
            title: documentData.title,
            route: getDebateNavLink(),
          },
          {
            title: 'Insights',
            route: `/document-details/${documentData._id}`,
          },
        ]"
      />
      <div>
        <div class="uk-inline">
          <div v-if="!!documentData" class="documnet-details-heading uk-margin-remove uk-flex">
            <span
              uk-icon="icon: arrow-up; ratio: 1.3"
              class="arrow-btn-up arrow-btn-color"
              :class="{ 'nav-disable': !showNavigationButton }"
              @click="navigate(-1)"
            ></span>
            <span
              uk-icon="icon: arrow-down; ratio: 1.3"
              class="arrow-btn-down arrow-btn-color"
              :class="{ 'nav-disable': !showNavigationButton }"
              @click="navigate(1)"
            ></span>

            <div class="head-details-title-container">
              <div class="heading-title-name">
                <span class="uk-margin-small-left"
                  ><i>{{ documentData.title || titleName }} </i></span
                >
                <span style="padding: 0 5px"
                  ><small>by {{ documentData.author || authorName }}</small></span
                >
              </div>
              <button type="button" class="btn-custom arrow-btn-color">
                <img src="/icons/black/icon-black-outline-node.svg" />
              </button>
              <div
                uk-dropdown="mode: click"
                class="width-max-details"
                ref="dropModalChildDebateDetails"
                id="dropModalChildDebateDetailsId"
              >
                <a
                  class="table-close"
                  uk-close
                  @click="UIkit.dropdown($refs.dropModalChildDebateDetails).hide()"
                  style="padding: 10px"
                ></a>
                <PrimeDataTable
                  ref="titleDetailsDataTable"
                  :tableConfig="tableChildDebateDetailsConfig"
                  :tableOptions="tableChildDebateDetailsOptions"
                  :loadDataFunction="getDebateList"
                  :pagination="false"
                  :columnChooser="false"
                  :scrollable="true"
                  scrollHeight="535px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="(!documentLoaded && !currentTeam) || counterPartData"
      style="position: relative; min-height: 5rem; height: 50vh"
    >
      <ResourceLoadStatus :loading="(!documentLoaded && !currentTeam) || counterPartData" />
    </div>

    <div v-else uk-grid class="uk-grid-small uk-child-width-1-2">
      <div class="uk-flex uk-flex-column">
        <DropdownBasicPanel title="Debate Activity" icon="/icons/discussion.svg">
          <div class="uk-flex uk-flex-between">
            <div class="uk-padding-small custom-card-view uk-background-muted uk-box-shadow-medium">
              <div class="">
                <div class="margin-bot-head">
                  <img src="/icons/black/icon-black-opposition-history.svg" alt="" width="27" />
                  <span class="uk-text-bold icon-padding-counterpart">Counterpart</span>
                  <button
                    v-if="addNew && teamLeadAccess.allowPublicDebate"
                    class="custom-add-btn display-large"
                    @click="EventBus.emit('workflow.next.inviteOpposition')"
                  >
                    Add&nbsp;+
                  </button>
                </div>
                <div
                  v-if="oppositionStatus === '' && !addNew"
                  class="invisible-divider"
                  style="height: 27px"
                />
                <div class="uk-flex uk-flex-between uk-margin-medium-left">
                  <span v-if="oppositionStatus !== ''">{{ oppositionStatus }}</span>
                  <button
                    v-if="addNew && teamLeadAccess.allowPublicDebate"
                    class="custom-add-btn display-normal"
                    @click="EventBus.emit('workflow.next.inviteOpposition')"
                  >
                    Add&nbsp;+
                  </button>
                </div>
                <div>
                  <div class="uk-text-bold">Round Status:</div>
                  <div class="uk-margin-medium-left">
                    {{ debateNextState?.current_round }} &nbsp;
                    {{ debateNextState?.current_status }}
                  </div>
                </div>
                <div>
                  <div class="uk-text-bold">Round Timer:</div>
                  <div class="uk-margin-medium-left">{{ dataTimeDiff }}</div>
                </div>
              </div>
            </div>
            <div class="uk-padding-small custom-card-view uk-background-muted uk-box-shadow-medium">
              <div class=" " uk-tooltip="title: Pending future release;">
                <div
                  class="margin-bot-head"
                  @click="clickTeamDisabled"
                  style="cursor: pointer"
                  :class="{
                    'icon-disable': isManageTeamDisabled,
                    badgeUserdisabled: permissionLevel === PermissionLevel.COHORT,
                  }"
                >
                  <BadgedIconButton
                    :customicon="true"
                    :icon="'/icons/icon-black-user.svg'"
                    :badgeValue="teamMembersBadge"
                    :small="true"
                    type="button"
                  />
                  <span class="uk-text-bold icon-padding">Team Lineup</span>
                </div>
                <div class="invisible-divider inv-divider-height" />
                <div class="icon-disable">
                  <div class="uk-text-bold">Response Ratio:</div>
                  <div class="uk-margin-medium-left">___/___</div>
                </div>
                <div class="icon-disable">
                  <div class="uk-text-bold">Selection Ratio:</div>
                  <div class="uk-margin-medium-left">___/___</div>
                </div>
              </div>
            </div>
            <div class="custom-card-view">
              <div class="uk-height-1-1">
                <div
                  class="uk-background-muted uk-padding-small uk-box-shadow-medium height-upper"
                  uk-tooltip="title: Pending future release;"
                >
                  <div class="margin-bot-head" style="cursor: pointer">
                    <!-- @click="openInstructionsModal" removed in line above for 0.5.8+ until general instructions are revisited as a feature -->
                    <BadgedIconButton
                      id="inlineRulesBtn"
                      :customicon="true"
                      :icon="'/icons/blue/icon-blue-inlinerule.svg'"
                      :badgeValue="
                        teamMemberData?.generalInstructionsViewed === false &&
                        permissionLevel === PermissionLevel.COHORT
                          ? // validation against false value is needed since we don't want to show a badge for null|undefined values
                            '!'
                          : null
                      "
                      type="button"
                      :small="true"
                      :class="{
                        'icon-disable':
                          generalInstructions?.instructions?.replaceAll(/<[/]?p>/g, '')?.trim() ===
                          '',
                      }"
                    />
                    <span class="uk-text-bold icon-disable">Team Coaching</span>
                  </div>
                  <div class="icon-disable responsive-margin-box">
                    <div class="uk-text-bold">Next Deadline:</div>
                    <div class="uk-margin-medium-left">MM/DD/YY 00:00</div>
                  </div>
                </div>
                <div @click="$router.push(getDebateNavLink())" class="height-lower margin-top-diss">
                  <img src="/icons/gotodiscussion.svg" width="30" />
                  <span class="m-left">Go to Discussion</span>
                </div>
              </div>
            </div>
          </div>
        </DropdownBasicPanel>

        <DropdownBasicPanel
          v-if="permissionLevel !== PermissionLevel.OBSERVER"
          title="Counterpart History"
          icon="/icons/black/icon-black-opposition-history.svg"
          :removeBottomPadding="true"
        >
          <div class="uk-flex-between">
            <div class="uk-margin-top">
              <table
                class="field-value-table uk-table uk-table-divider uk-table-small bottom-table"
              >
                <tbody>
                  <tr v-for="(fields, index) in oppositionHistoryFields" :key="index">
                    <td
                      v-for="(value, key, i) in fields[0]"
                      :key="i"
                      class="field-value-table-cell field-data-font"
                      :class="{ 'uk-text-bolder': key === 'label' }"
                    >
                      <span class="uk-flex uk-flex-middle">{{
                        key === 'label' ? fields[0][key] : oppositionHistory[fields[0][key]]
                      }}</span>
                    </td>
                    <td
                      v-for="(value, key, i) in fields[1]"
                      :key="'i' + i"
                      class="field-value-table-cell field-data-font"
                      :class="{
                        'uk-text-bolder': key === 'label',
                        'uk-flex': fields[1][key] === 'Team Lead:',
                      }"
                    >
                      <span class="uk-flex uk-flex-middle">{{
                        key === 'label' ? fields[1][key] : oppositionHistory[fields[1][key]]
                      }}</span>
                      <button
                        v-if="
                          fields[1][key] === 'Team Lead:' && userId === documentData.createdBy?._id
                        "
                        uk-icon="icon: history;"
                        id="inlineRulesBtnHistory"
                        uk-tooltip="See the invitee history"
                        class="history-field"
                        @click="UIkit.dropdown($refs.previousInviteeModal).show()"
                      ></button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div
                uk-dropdown="target: #inlineRulesBtnHistory; mode: click"
                class="previous-invite"
                ref="previousInviteeModal"
                id="previousInviteeModal"
              >
                <a
                  class="table-close"
                  uk-close
                  @click="UIkit.dropdown($refs.previousInviteeModal).hide()"
                  style="margin: 2px 2px 0 0"
                ></a>
                <PrimeDataTable
                  :key="inviteUpdate"
                  ref="previousInviteeDataTable"
                  :tableConfig="tablePreviousInviteeConfig"
                  :tableOptions="tablePreviousInviteeOptions"
                  :loadDataFunction="getInviteList"
                  :pagination="false"
                  :columnChooser="false"
                  :scrollable="true"
                  scrollHeight="180px"
                  style="padding-top: 23px"
                />
              </div>
              <div
                v-if="invitationSent"
                class="uk-width-1-1 main-contain-challenge-url"
                :key="linkBoxUpdated"
              >
                <div
                  class="challenge-url-details uk-flex"
                  :class="{ ' uk-flex-between': !addButtonStatus }"
                >
                  <span class="uk-text-bold challenge-label-width">Challenge URL: </span>
                  <div class="uk-width-1-3 uk-flex uk-flex-between" style="flex: 1">
                    <a
                      v-if="generateLink && addButtonStatus"
                      :href="randomLink"
                      target="_blank"
                      class="ellipsis-link"
                    >
                      {{ randomLink }}
                    </a>
                    <span
                      v-if="generateLink && addButtonStatus"
                      uk-icon="icon: copy"
                      class="uk-icon copy-icon-effect challenge-url-margin-copy-icon"
                      style="cursor: pointer; margin-top: 6px"
                      :uk-tooltip="'Copy the link'"
                      @click="copyText(randomLink)"
                    />
                  </div>
                  <button
                    v-if="!addButtonStatus"
                    type="button"
                    class="custom-add-btn uk-flex uk-border-rounded"
                    :class="{ 'link-btn-top': randomLinkStatus === LoadingStatus.LOADING }"
                    @click="generateCallLink"
                  >
                    <span>Add&nbsp;+</span>
                    <InlineLoader
                      v-if="randomLinkStatus !== LoadingStatus.NONE && inlineLoaderShow"
                      :status="randomLinkStatus"
                      :smallSpinner="true"
                      class="uk-margin-small-left"
                      style="margin-top: -5px"
                    />
                  </button>
                </div>
              </div>
              <!-- <ResourceLoadStatus v-if="counterPartData" :loading="counterPartData"/>
              <FieldValueTable  v-else :fields="oppositionHistoryFields" :data="oppositionHistory" :isCounterpart="true" :addNew="addNew"/> -->
            </div>
          </div>
        </DropdownBasicPanel>
        <DropdownBasicPanel
          v-else
          title="Counterpart History"
          icon="/icons/black/icon-black-opposition-history.svg"
          :removeBottomPadding="true"
          :disable="true"
          tooltip="title: Not available for observers; pos: left;"
        >
        </DropdownBasicPanel>
        <DropdownBasicPanel
          v-if="permissionLevel === PermissionLevel.TEAM_LEAD"
          tooltip=""
          title="Audience Engagement"
          icon="/icons/publicengage.svg"
        >
          <div class="uk-position-relative">
            <div
              v-if="documentData?.privacy !== 'Public' || publicLinks.length === 0"
              class="uk-flex public-padding-side"
            >
              <span class="uk-text-bold private-label-width">Shareable Reaction Link: </span>
              <span v-if="documentData?.privacy === 'Optional'" class="uk-width-2-3"
                >Waiting for counterpart to set privacy.</span
              >
              <span v-else class="uk-width-2-3">Private discussion, no link is available.</span>
            </div>
            <template v-else>
              <div
                v-for="link in publicLinks"
                :key="`${publicLinks.length}${link._id}`"
                class="public-padding-side uk-flex"
              >
                <span
                  class="uk-text-bold"
                  :class="{
                    'public-label-width-opp': currentTeam?.oppositionTeam,
                    'public-label-width': !currentTeam?.oppositionTeam,
                  }"
                  >Shareable Reaction Link:
                </span>
                <div class="uk-width-2-3 uk-flex uk-flex-between" style="flex: 1">
                  <a :href="getPublicLinkURL(link)" target="_blank" class="ellipsis-link">
                    {{ getPublicLinkURL(link) }}
                  </a>
                  <span
                    uk-icon="icon: copy"
                    class="uk-icon copy-icon-effect public-url-margin-copy-icon"
                    style="cursor: pointer; margin-top: 6px"
                    :uk-tooltip="'Copy the link'"
                    @click="copyText(getPublicLinkURL(link))"
                  />
                </div>
              </div>
            </template>

            <PrimeDataTable
              :columnChooser="false"
              ref="dataTable"
              :loadDataFunction="publicEngagmentFunction"
              :tableConfig="tableConfigPublicEngagement"
              :tableOptions="tableOptions"
              :page-size="6"
              :pagination="false"
            />
          </div>
        </DropdownBasicPanel>
        <DropdownBasicPanel
          v-else
          title="Audience Engagement"
          icon="/icons/publicengage.svg"
          :removeBottomPadding="true"
          :disable="true"
          tooltip="title: Only available for Team Leads; pos: left;"
        >
        </DropdownBasicPanel>
        <DropdownBasicPanel
          :disable="true"
          title="Social Media"
          icon="/icons/icon-sharing.svg"
          v-if="permissionLevel !== PermissionLevel.COHORT"
          tooltip="title: Pending future release; pos: left;"
        >
        </DropdownBasicPanel>
      </div>
      <!-- end of column -->
      <div class="uk-flex uk-flex-column">
        <DropdownBasicPanel
          :removeBottomPadding="fieldOpen"
          :title="`${debateStatus?.rounds?.length === 0 && debateNextState?.current_status !== 'Published' ? 'Pre-' : ''}Discussion Framing`"
          icon="/icons/black/icon-black-book.svg"
        >
          <FieldValueTable
            :fields="baseFields"
            :data="documentData"
            :isCustomField="true"
            :customFieldData="currentTeam?.custom_fields"
          />
        </DropdownBasicPanel>

        <DropdownBasicPanel
          :title="'Content Summary'"
          icon="/icons/summary.svg"
          class="uk-width-1-1"
          :disable="true"
          tooltip="title: Pending future release; pos: left;"
        >
          <div
            id="summary"
            v-if="
              [DocumentType.ARTICLE, DocumentType.TEXT].includes(documentSelectedSource.sourceType)
            "
          >
            <div class="uk-flex uk-position-relative">
              <span style="font-size: var(--global-large-font-size)"><b>Thesis:</b></span>
              <span style="font-size: var(--global-large-font-size)" class="uk-margin-small-left">{{
                documentSelectedSource.thesis?.nodeContent
              }}</span>
              <div
                class="outline-node-line outline-node-line-parent"
                :style="{
                  height: getparentHeight(),
                  left: '2px',
                  top: '2.25em',
                }"
              ></div>
            </div>
            <ul id="outlines" class="uk-list uk-margin-large-left">
              <li
                :id="`child-${idx}`"
                class="uk-position-relative"
                v-for="(summaryPoint, idx) in documentSelectedSource.summary?.slice(0, 5)"
                :key="summaryPoint?._id"
              >
                <div
                  class="outline-node-line outline-node-line-child"
                  style="left: -3.25em; top: 0.8em; width: 2.5em"
                ></div>
                <div class="uk-flex">
                  <span style="font-size: var(--global-large-font-size)"
                    ><b>Outline Point {{ idx + 1 }}: </b></span
                  >
                  <span
                    style="font-size: var(--global-large-font-size)"
                    class="uk-margin-small-left uk-width-3-4"
                    >{{ summaryPoint?.nodeContent }}</span
                  >
                </div>
              </li>
            </ul>
            <div
              v-if="roundFollowingMyLatestRound?.team && roundFollowingMyLatestRound?.invitation"
            >
              {{ roundFollowingMyLatestRound.invitation.name }} Invited (Invitation
              {{ roundFollowingMyLatestRound.invitation.status }})
            </div>
          </div>
        </DropdownBasicPanel>
      </div>
      <!-- end of column -->
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import PermissionLevel from '@/assets/js/enum/PermissionLevel';
import DocumentType from '@/assets/js/enum/DocumentType';
import DropdownBasicPanel from '@/components/display/general/DropdownBasicPanel';
import FieldValueTable from '@/components/display/general/FieldValueTable';
import BasicModal from '@/components/display/general/BasicModal';
import ResourceLoadStatus from '@/components/general/ResourceLoadStatus';
import LoadingStatus from '@/assets/js/enum/LoadingStatus';
import BreadCrumb from '@/components/general/BreadCrumb';
import GeneralInstructions from '@/components/annotations/GeneralInstructions';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import InlineLoader from '@/components/general/InlineLoader';
import { EventBus } from '@/assets/js/event-bus';
import { xhr } from '@/xhr/endpoints';
import UIkit from 'uikit';

export default {
  name: 'DocumentDetails',
  components: {
    FieldValueTable,
    ResourceLoadStatus,
    BasicModal,
    PrimeDataTable: defineAsyncComponent(() => import('@/components/table/PrimeDataTable.vue')),
    DropdownBasicPanel,
    BreadCrumb,
    GeneralInstructions,
    BadgedIconButton: defineAsyncComponent(
      () => import('@/components/display/button/BadgedIconButton.vue')
    ),
    InlineLoader,
  },
  data() {
    return {
      invitedOppositionMember: null,
      summary: null,
      currentPublicLink: { permissions: [] },
      publicLinkModalActionStatus: '',
      debateList: [],
      publicLinks: [],
      showNavigationButton: false,
      publicEngagementFieldLabels: {
        unique_visitors: 'Unique Visitors',
        // repeat_visitors: "Repeat Visitors",
        // average_pageview_duration: "Avg. Pageview Duration",
        total_likes: 'Positive',
        total_dislikes: 'Negative',
        // facebook: "Facebook Shares",
        // linkedin: "LinkedIn Shares",
        // twitter: "Twitter Shares",
        // email: "Email Shares",
      },
      publicEngagementData: {},
      loadingPublicInteractionsStatus: '',
      publicEngagementDataLoaded: false,
      tableOptions: {
        tableName: 'tableDocumentDetails',
        // dataView: {
        //   label: "Filter by:",
        //   options: [
        //     { label: "Current Document Only", value: "parent" },
        //     { label: "Citation Documents", value: "children" },
        //     { label: "All Related Documents", value: "all" },
        //   ],
        // },
      },
      currentRound: 0,
      saveInstructionsStatus: '',
      instructionsModalOpen: false,
      addNew: true,
      dates: [],
      avgTime: '',
      counterPartData: true,
      dataTimeDiff: '',
      inviteList: [],
      inviteeStatus: [],
      inviteUpdate: 0,
      titleName: '',
      documentOwnersNames: [],
      routerDetails: 0,
      currentIndex: 0,
      generateLink: false,
      randomLink: '',
      linkBoxUpdated: 0,
      randomLinkStatus: '',
      addButtonStatus: false,
      fieldOpen: true,
      inlineLoaderShow: false,
    };
  },
  computed: {
    UIkit() {
      return UIkit;
    },
    PermissionLevel() {
      return PermissionLevel;
    },
    EventBus() {
      return EventBus;
    },
    ...mapState([
      'userData',
      'documentData',
      'debateStatus',
      'tooltips',
      'documentLoaded',
      'generalInstructions',
      'currentTeam',
      'debateNextState',
      'teamLeadAccess',
    ]),
    ...mapGetters([
      'documentID',
      'userId',
      'roundFollowingMyLatestRound',
      'ukTooltip',
      'documentSelectedSource',
      'getPublicLinkURL',
      'teamMemberData',
      'permissionLevel',
      'teamID',
      'documentMode',
      'tableToggleData',
      'sortAndFilter',
    ]),
    tableChildDebateDetailsOptions() {
      return {
        globalFilterFields: ['title', 'author', 'articleTitle'],
        placeHolderData: true,
        tableName: 'debateList',
      };
    },
    LoadingStatus() {
      return LoadingStatus;
    },
    tableChildDebateDetailsConfig() {
      const tableConfig = [
        {
          column: 'Debate Title',
          field: 'title',
          model: row => {
            return row.title;
          },
          link: row => {
            return this.$router.routesMap.DocumentDetails(row.id);
          },
          action: this.adminMode
            ? row => this.$emit('adminModeNavigate', this.$router.routesMap.DocumentDetails(row.id))
            : undefined,
          sortable: true,
          ellipsis: true,
        },
        {
          column: 'Article Author',
          field: 'author',
          model: row => {
            return row.author;
          },
          filter: {
            type: 'select',
            options: [...this.documentOwnersNames],
          },
          sortable: true,
        },
        {
          column: 'Content Title',
          field: 'articleTitle',
          model: row => {
            return row.articleTitle;
          },
          sortable: true,
          ellipsis: true,
        },
      ];
      return tableConfig;
    },
    tablePreviousInviteeOptions() {
      return {
        placeHolderData: true,
        tableName: 'previousInvitee',
      };
    },

    tablePreviousInviteeConfig() {
      const tableConfig = [
        {
          column: 'Invitee',
          field: 'firstname',
          model: row => {
            return row.firstname + ' ' + row.lastname;
          },
          sortable: true,
          ellipsis: true,
        },
        {
          column: 'Status',
          field: 'status',
          model: row => {
            return row.status;
          },
          sortable: true,
        },
        {
          column: 'Date Invited',
          field: 'dateInvited',
          model: row => {
            let date = new Date(row.updatedAt);
            return `${date.toLocaleDateString('en-us', { day: '2-digit', month: '2-digit', year: 'numeric' })}`;
          },
          sortable: true,
          ellipsis: true,
        },
      ];
      return tableConfig;
    },
    baseFields() {
      const sourceFields =
        this.documentSelectedSource.sourceType === DocumentType.ARTICLE
          ? [
              {
                label: 'Source Link:',
                field: () => this.documentSelectedSource.sourceURL,
                type: ['function', 'link'],
                allowCopyLink: true,
              },
            ]
          : [];

      const documentFields = [
        {
          label: 'Debate Title:',
          field: 'title',
          editable:
            this.debateStatus?.rounds?.length === 0 &&
            this.permissionLevel !== PermissionLevel.COHORT &&
            this.debateNextState?.current_status !== 'Published',
        },
        {
          label: 'Content Title:',
          field: 'articleTitle',
          editable:
            this.debateStatus?.rounds?.length === 0 &&
            this.permissionLevel !== PermissionLevel.COHORT &&
            this.debateNextState?.current_status !== 'Published',
        },
        {
          label: 'Publisher:',
          field: 'publication',
          editable:
            this.debateStatus?.rounds?.length === 0 &&
            this.permissionLevel !== PermissionLevel.COHORT &&
            this.debateNextState?.current_status !== 'Published',
          label2: 'Published:',
          field2: 'publicationDate',
          type2: ['date'],
          editable2:
            this.debateStatus?.rounds?.length === 0 &&
            this.permissionLevel !== PermissionLevel.COHORT &&
            this.debateNextState?.current_status !== 'Published',
        },
        {
          label: 'Author:',
          field: 'author',
          editable:
            this.debateStatus?.rounds?.length === 0 &&
            this.permissionLevel !== PermissionLevel.COHORT &&
            this.debateNextState?.current_status !== 'Published',
          label2: 'Submitted:',
          field2: 'createdAt',
          type2: ['date'],
          editable2: false,
        },
      ];

      return [...documentFields, ...sourceFields];
    },
    invitationSent() {
      return this.currentTeam?.oppositionTeam
        ? false
        : this.debateNextState?.current_status === 'Published'
          ? true
          : false;
    },
    oppositionStatus() {
      return this.currentTeam?.oppositionTeam ? this.currentTeam?.oppositionTeam?.status : 'None';
    },
    oppositionHistoryFields() {
      return [
        [
          { label: 'Last Action:', field: 'lastReply' },
          { label: 'Team Lead:', field: 'oppositionlead' },
        ],
        [
          { label: 'Team Size:', field: 'teamSize' },
          { label: 'Privacy:', field: 'privacySelection' },
        ],
        [
          { label: 'Avg Round Time:', field: 'avgTimeInRound' },
          { label: 'Date Invited:', field: 'dateInvited' },
        ],
      ];
    },

    oppositionHistory() {
      let data = {
        oppositionlead: '',
        dateInvited: '--',
        lastReply: '',
        teamSize: '',
        avgTimeInRound: '',
        privacySelection: '',
      };
      if (this.currentTeam?.oppositionTeam) {
        let displayName =
          this.currentTeam?.oppositionTeam?.teamLead?.firstname?.trim() +
          ' ' +
          (this.currentTeam?.oppositionTeam?.teamLead?.lastname?.trim() !== undefined
            ? this.currentTeam?.oppositionTeam?.teamLead?.lastname?.trim()
            : '');
        data.oppositionlead = displayName;
        ((data.dateInvited =
          new Date(this.currentTeam?.oppositionTeam?.invitedAt).toLocaleDateString('en-us', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
          }) === 'Invalid Date'
            ? this.currentTeam?.oppositionTeam?.invitedAt
            : new Date(this.currentTeam?.oppositionTeam?.invitedAt).toLocaleDateString('en-us', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              })),
          (data.teamSize = this.currentTeam?.members?.length),
          (data.privacySelection =
            this.documentData?.privacy === 'Optional' ? 'TBD' : this.documentData?.privacy));
        data.avgTimeInRound = this.currentTeam?.oppositionTeam?.avgTimeInRound
          ? this.formatTime(this.currentTeam?.oppositionTeam?.avgTimeInRound * 1000)
          : 'N/A';
        if (this.currentTeam?.oppositionTeam?.lastReply) {
          data.lastReply =
            new Date(this.currentTeam?.oppositionTeam?.lastReply).toLocaleDateString('en-us', {
              day: 'numeric',
              month: 'short',
              year: 'numeric',
            }) === 'Invalid Date'
              ? this.currentTeam?.oppositionTeam?.lastReply
              : new Date(this.currentTeam?.oppositionTeam?.lastReply).toLocaleDateString('en-us', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                });
        }
      }
      return data;
    },

    getInternalURL() {
      return `${window.location.origin}/#/document-details/${
        this.documentID
      }?title=${encodeURIComponent(this.documentData.title)}`;
    },
    documentTitle() {
      return this.documentData.title;
    },
    authorName() {
      return this.documentData.author ? this.documentData.author.name : '';
    },
    namedParties() {
      return this.documentData.namedParties
        ? this.documentData.namedParties.map(np => {
            return { name: np.name };
          })
        : [];
    },
    teamMembersBadge() {
      return this.currentTeam && this.currentTeam.team_lineup ? this.currentTeam.team_lineup : '-';
    },
    instructionsBadge() {
      return this.generalInstructions && this.generalInstructions.instructions
        ? this.generalInstructions.instructions.length
        : 0;
    },
    annotationsBadge() {
      return 0;
    },

    DocumentType() {
      return DocumentType;
    },
    teamInstructionToolTip() {
      return this.permissionLevel === 'Team Member'
        ? 'View Team Instructions'
        : 'Update Team Instructions';
    },

    tableConfigPublicEngagement() {
      const tableConfigPublicEngagement = [
        {
          column: 'Reactions',
          field: 'label',
          model: row => this.publicEngagementFieldLabels[row.label],
          sortable: false,
          center: true,
        },
        {
          column: 'My Side',
          field: 'currentTeam',
          position: 'center',
          sortable: false,
          model: row => row.myteam,
          headcenter: true,
        },
        {
          column: "Counterpart's Side",
          field: 'oppositionTeam',
          position: 'center',
          sortable: false,
          model: row => row.opposingteam,
          headcenter: true,
        },
        {
          column: 'Total',
          field: 'total',
          position: 'center',
          model: row => row.total,
          sortable: false,
          headcenter: true,
        },
      ];
      return tableConfigPublicEngagement;
    },

    /**
     * Buttons to show on instruction modal
     */
    instructionsModalButtons() {
      return this.permissionLevel === PermissionLevel.COHORT
        ? // buttons for team member
          [
            {
              label: 'Close',
              action: this.closeInstructionsModal,
            },
          ]
        : // buttons for team leader
          [
            {
              label: 'Close',
              action: this.closeInstructionsModal,
            },
            {
              label: 'Save',
              action: this.saveInstructions,
              style: 'primary',
            },
          ];
    },

    isManageTeamDisabled() {
      return !!this.teamMemberData?._id;
    },
    linkOrigin() {
      return window.location.origin;
    },
    randomLinGenerate() {
      if (this.generateLink) {
        let randomString = '';
        if (this.documentData.challengeUrl) {
          randomString = this.documentData.challengeUrl;
        } else {
          randomString = this.generateRandomString(20); // Change the length as needed
        }
        return randomString;
      }
      return '';
    },
  },
  watch: {
    debateList(value) {
      if (value) {
        this.showNavigationButton = true;
      }
    },
    '$route.params': {
      deep: true,
      immediate: true,
      handler(to, from) {
        if (to?.documentID !== from?.documentID) {
          this.$router.routesMap.DocumentDetails(to.documentID);
          this.setCurrentDocumentID(to.documentID);
          this.routerDetails += 1;
          if (from !== undefined) {
            this.debateInit();
          }
          UIkit.dropdown(document.getElementById('dropModalChildDebateDetailsId')).hide();
        }
      },
    },
  },
  async mounted() {
    this.debateInit();
    EventBus.on('custom.field.open', this.customFieldOpen);
  },

  beforeUnmount() {
    this.setDocumentLoaded(false);
    EventBus.emit('hide.modals');
    EventBus.off('custom.field.open', this.customFieldOpen);
    EventBus.off('share.twitter', this.openTwitterModal);
    EventBus.off('invite.list.update', this.inviteUpdateData);
  },

  methods: {
    ...mapActions([
      'getDocumentDetails',
      'copyLinkToClipboard',
      'getTotalDocumentLikesData',
      'getAllVisitorsCountForPublicLinks',
      'loadPublicInteractionData',
      'openTwitterBrowserModal',
      'saveGeneralInstructions',
      'loadTeamDetails',
      'setGeneralInstructionsViewed',
      'addSessionLog',
      'updateDocument',
      'retrieveDebateNextState',
      'getTeamLeadAccess',
    ]),

    ...mapMutations(['setDocumentLoaded', 'setCurrentDocumentID']),
    async debateInit() {
      await this.getDocumentDetails({
        documentId: this.$route.params.documentID,
        successFn: async () => {
          // this.addSessionLog({
          //   location: 'DocumentDetails.vue: mounted: getDocumentDetails',
          //   initialStance: res.initialStance,
          //   sourceType: res.documentType,
          // })
          const linksForCurrentUser =
            this.documentData.outputLinks?.filter(link => link.team_id === this.teamID) || [];
          this.currentRound = this.debateStatus?.rounds?.length;
          this.publicLinks = linksForCurrentUser;
          this.setDocumentLoaded(true);
        },
      });
      //
      // load team details in order to get general instructions data
      await this.loadTeamDetails(this.teamID);
      UIkit.util.on(this.$refs.instrucitonsModal, 'hidden', async () => {
        this.instructionsModalOpen = false;
      });
      await this.retrieveDebateNextState();
      this.counterPartData = false;
      if (
        this.currentTeam?.oppositionTeam?.status === 'Accepted' ||
        (this.currentRound < 1 && this.documentData.initialStance === 'Host') ||
        this.userId !== this.documentData.createdBy?._id
      ) {
        this.addNew = false;
      } else {
        this.addNew = true;
      }

      EventBus.on('share.twitter', this.openTwitterModal);
      EventBus.on('invite.list.update', this.inviteUpdateData);
      this.debateStatus?.rounds.map(date => {
        this.dates.push(new Date(`${date.updated_at}`));
      });

      const timestamps = this.dates.map(dateString => new Date(dateString).getTime());
      const date1 = new Date(timestamps[0]);
      const date2 = new Date(timestamps[timestamps.length - 1]);
      const diffTime = Math.abs(date2 - date1) / timestamps.length - 1;
      const minutes = Math.floor((diffTime / 1000 / 60) % 60);
      const hours = Math.floor((diffTime / 1000 / 60 / 60) % 24);
      let days = Math.floor(hours / 24);
      const formattedTime = [
        days.toString().padStart(2, '0'),
        hours.toString().padStart(2, '0'),
        minutes.toString().padStart(2, '0'),
      ].join(':');
      this.avgTime = timestamps.length <= 1 || isNaN(diffTime) ? false : formattedTime;
      this.getTimeDifference(date2);
      if (this.documentData.challengeUrl !== null) {
        this.generateLink = true;
        this.addButtonStatus = true;
        this.linkBoxUpdated = +1;
        this.randomLink = this.documentData.challengeUrl;
      }
    },
    customFieldOpen(val) {
      this.fieldOpen = val;
    },
    inviteUpdateData() {
      this.inviteUpdate = +1;
      if (this.documentData.challengeUrl !== null) {
        this.generateLink = true;
        this.addButtonStatus = true;
        this.linkBoxUpdated = +1;
        this.randomLink = this.documentData.challengeUrl;
      }
    },
    async generateCallLink() {
      this.inlineLoaderShow = true;
      this.randomLinkStatus = LoadingStatus.LOADING;
      this.generateLink = true;
      this.addButtonStatus = false;
      let body = { challengeUrl: this.randomLinGenerate };
      let res = await this.updateDocument({ documentData: body, setData: false });
      if (res) {
        this.addButtonStatus = true;
        this.inlineLoaderShow = false;
        this.randomLinkStatus = LoadingStatus.NONE;
        this.randomLink = res.challengeUrl;
      }
    },
    generateRandomString(length) {
      const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
      let result = '';
      for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        result += characters.charAt(randomIndex);
      }
      return result;
    },
    copyText(text) {
      navigator.clipboard.writeText(text);
    },
    async getDebateList({ page, sortColumn, sortDirection, filters }) {
      if (this.showNavigationButton) return this.debateList;
      this.debateList = await xhr.getDebateList(
        this.userId,
        page,
        sortColumn,
        sortDirection,
        filters
      );
      this.documentOwnersNames = [];
      if (filters?.archived?.value) {
        this.debateList.debateList.map(item => {
          if (!this.documentOwnersNames.includes(item.author))
            this.documentOwnersNames.push(item.author);
        });
      } else {
        this.debateList.debateList.map(item => {
          if (!this.documentOwnersNames.includes(item.author))
            this.documentOwnersNames.push(item.author);
        });
      }
      filters.searchScope = ['title', 'author', 'articleTitle'];
      this.debateList.debateList = this.sortAndFilter({
        data: this.debateList.debateList,
        sortColumn,
        sortDirection,
        filters,
      });
      return this.debateList;
    },
    setIndexFromURL() {
      const debateIdFromURL = this.$route.params.documentID;
      const index = this.debateList.debateList.findIndex(debate => debate.id === debateIdFromURL);
      this.currentIndex = index;
    },
    navigate(direction) {
      this.setIndexFromURL();
      if (this.debateList.debateList.length === 0) return;
      this.currentIndex =
        (this.currentIndex + direction + this.debateList.debateList.length) %
        this.debateList.debateList.length;
      const debateId = this.debateList.debateList[this.currentIndex].id;
      this.updateURL(debateId);
    },
    updateURL(debateId) {
      const baseUrl = `${window.location.origin}/#/document-details/`;
      const url = baseUrl + debateId;
      window.location.href = url;
    },
    async getInviteList({ page, sortColumn, sortDirection, filters }) {
      this.inviteList = await xhr.getInviteList(
        this.documentID,
        page,
        sortColumn,
        sortDirection,
        filters
      );
      this.inviteList.results = this.inviteList.results.filter(
        item => item.firstname !== '' && item.lastname !== ''
      );
      this.inviteeStatus = [];
      if (filters?.archived?.value) {
        this.inviteList.results.map(item => {
          if (!this.inviteeStatus.includes(item.status)) this.inviteeStatus.push(item.status);
        });
      } else {
        this.inviteList.results.map(item => {
          if (!this.inviteeStatus.includes(item.status)) this.inviteeStatus.push(item.status);
        });
      }
      filters.searchScope = ['status'];
      this.inviteList.results = this.sortAndFilter({
        data: this.inviteList.results,
        sortColumn,
        sortDirection,
        filters,
      });
      return this.inviteList;
    },
    getTimeDifference(date) {
      let date_past = new Date(date);
      let date_now = new Date();
      let seconds = Math.floor((date_now - date_past) / 1000);
      let minutes = Math.floor(seconds / 60);
      let hours = Math.floor(minutes / 60);
      let days = Math.floor(hours / 24);

      hours = hours - days * 24;
      minutes = minutes - days * 24 * 60 - hours * 60;
      seconds = seconds - hours * 60 * 60 - minutes * 60;
      if (hours < 10) {
        hours = '0' + hours;
      }
      if (minutes < 10) {
        minutes = '0' + minutes;
      }
      if (days < 10) {
        days = '0' + days;
      }
      this.dataTimeDiff = isNaN(hours) ? '00:00:00' : `${days}:${hours}:${minutes}`;
    },
    getparentHeight() {
      let height = document.getElementById('summary')?.offsetHeight || 0;
      let lastChildHeight = document.getElementById('outlines')?.children || [];
      lastChildHeight = [...lastChildHeight]?.at(-1)?.offsetHeight || 0;
      return `calc(${height}px - 2.25em - ${lastChildHeight}px + 0.8em)`;
    },

    openTwitterModal(annotation, url) {
      this.openTwitterBrowserModal({
        window,
        linkId: this.publicLinks[0]._id,
        docId: this.documentData._id,
        docTitle: this.documentData.title,
        url,
      });
    },

    formatTime(milliseconds) {
      const hoursGap = new Date(0).getHours();
      const adjustedTime = new Date(milliseconds - hoursGap * 60 * 60 * 1000);
      return adjustedTime
        .toTimeString('en-US', {
          hours: 'number',
          minutes: '2-digit',
          seconds: '2-digit',
        })
        .replace(/ GMT[\w\W]+/, '');
    },

    openPublicLinkModal(publicLink) {
      this.publicLinkModalActionStatus = LoadingStatus.NONE;
      this.currentPublicLink = publicLink;
      UIkit.modal(this.$refs.publicLinkModal).show();
    },

    async setPublicInteractionData(value) {
      this.publicEngagementDataLoaded = false;
      let uniqueVisitors = 0;
      let repeatVisitors = 0;
      let averagePageviewDuration = 0;
      let totalLikes = 0;
      let totalDislikes = 0;

      try {
        const visitorCounts = await this.getAllVisitorsCountForPublicLinks(value);
        uniqueVisitors = visitorCounts.uniqueVisits;
      } catch (err) {
        console.log(err);
      }

      try {
        const likesData = await this.getTotalDocumentLikesData(value);
        totalLikes = likesData.likes;
        totalDislikes = likesData.dislikes;
      } catch (err) {
        console.log(err);
      }

      this.publicEngagementData = {
        unique_visitors: uniqueVisitors,
        repeat_visitors: repeatVisitors,
        average_pageview_duration: averagePageviewDuration,
        total_likes: totalLikes,
        total_dislikes: totalDislikes,
      };
      this.publicEngagementDataLoaded = true;
    },

    getDebateNavLink() {
      return this.$router.routesMap.Debate(this.documentID);
    },

    openInstructionsModal() {
      this.instructionsModalOpen = true;
      if (
        this.permissionLevel === PermissionLevel.COHORT &&
        !this.teamMemberData.generalInstructionsViewed
      ) {
        this.setGeneralInstructionsViewed({
          teamID: this.teamID,
          teamMemberId: this.teamMemberData._id,
          successFn: () => {
            this.teamMemberData.generalInstructionsViewed = true;
          },
        });
      }
      this.saveInstructionsStatus = LoadingStatus.NONE;
      UIkit.dropdown(this.$refs.instrucitonsModal).show();
    },

    closeInstructionsModal() {
      UIkit.dropdown(this.$refs.instrucitonsModal).hide(0);
      this.instructionsModalOpen = false;
    },

    async saveInstructions() {
      if (this.generalInstructions.timeframes.at(-1).timeframeThreshold) {
        this.saveInstructionsStatus = LoadingStatus.LOADING;
        await this.saveGeneralInstructions({
          teamID: this.teamID,
          generalInstructions: {
            instructions: this.generalInstructions.instructions,
            timeframeThreshold: parseFloat(
              this.generalInstructions.timeframes.at(-1).timeframeThreshold
            ),
            timeframeEnabled: this.generalInstructions.timeframes.at(-1).enabled,
          },
          successFn: () => {
            this.saveInstructionsStatus = LoadingStatus.SUCCESS;
          },
          failedFn: () => {
            this.saveInstructionsStatus = LoadingStatus.FAILED;
          },
        });
        this.closeInstructionsModal();
      } else {
        EventBus.emit('generalinstruction.dateerror', '');
      }
    },

    clickTeamDisabled() {
      if (!this.isManageTeamDisabled) {
        this.$router.push(`/team-settings/${this.documentID}/${this.teamID}`);
      }
    },
    publicEngagmentFunction() {
      let data = this.documentData.teams;
      const result = [
        // {
        //   myteam: data[0].repeat_visitors,
        //   opposingteam: data[1].repeat_visitors,
        //   total: (data[0]?.repeat_visitors || 0) + (data[1]?.repeat_visitors || 0),
        //   label: "repeat_visitors"
        // },
        {
          myteam: data[0].id === this.teamID ? data[0]?.total_likes : data[1]?.total_likes,
          opposingteam: data[0].id !== this.teamID ? data[0]?.total_likes : data[1]?.total_likes,
          total: (data[0]?.total_likes || 0) + (data[1]?.total_likes || 0),
          label: 'total_likes',
        },
        {
          myteam: data[0].id === this.teamID ? data[0]?.total_dislikes : data[1]?.total_dislikes,
          opposingteam:
            data[0].id !== this.teamID ? data[0]?.total_dislikes : data[1]?.total_dislikes,
          total: (data[0]?.total_dislikes || 0) + (data[1]?.total_dislikes || 0),
          label: 'total_dislikes',
        },
        {
          myteam: data[0].id === this.teamID ? data[0]?.unique_visitors : data[1]?.unique_visitors,
          opposingteam:
            data[0].id !== this.teamID ? data[0]?.unique_visitors : data[1]?.unique_visitors,
          total: (data[0]?.unique_visitors || 0) + (data[1]?.unique_visitors || 0),
          label: 'unique_visitors',
        },
        // {
        //   myteam: data[0].average_pageview_duration,
        //   opposingteam: data[1].average_pageview_duration,
        //   total: "", // You didn't specify how to calculate the total duration
        //   label: "average_pageview_duration"
        // }
      ];

      return {
        results: result,
        totalCount: 1,
      };
    },
  },
};
</script>

<style lang="scss">
.custom-add-btn {
  background: #517f91;
  border-radius: 5px;
  padding: 6px;
  margin-top: 3px;
  color: white;
  border: none;
  height: 27px;
  cursor: pointer;
}
</style>
<style lang="scss" scoped>
.history-field {
  margin: 0 0 0 6px;
}
.shareable-link-container {
  word-break: break-all;
}
.custom-card-view {
  // Mimic UKit card style
  font-size: 0.8125rem;
  width: 35%;
  margin: 10px;
}
.overflow-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  border: 1px solid #919393;
  border-radius: 8px 0px 0px 8px;
  padding: 8px 16px 8px 16px;
  color: #999999;
}

.copy-link-btn {
  border: 1px solid #919393;
  border-radius: 0px 8px 8px 0px;
  padding: 8px 16px 8px 16px;
  color: #999999;
  background-color: #3773cd;
  color: white;
  width: 16rem;
  height: auto;
  font-size: $global-large-font-size;
  aspect-ratio: 1.1;
}

.copy-link-btn:active {
  background-color: #204885;
}
.ratio-size {
  font-size: $global-xlarge-font-size;
  color: black;
}

.ratio-text {
  margin-top: -14px;
}
.badgeUserdisabled {
  pointer-events: none;
  opacity: 0.5;
}
.icon-disable {
  opacity: 0.5;
  cursor: default !important;
}
.general-instruction {
  right: 23%;
  top: 23% !important;
  left: auto !important;
  width: 28%;
  @media only screen and (max-width: 1800px) {
    width: 35%;
  }
  @media only screen and (max-width: 1800px) {
    width: 40%;
  }
}
.inv-divider-height {
  height: 34px;
  @media only screen and (max-width: 1720px) {
    height: 0;
  }
}
.responsive-margin-box {
  margin-top: 36px;
  @media only screen and (max-width: 1881px) {
    margin-top: 2px;
  }
  @media only screen and (max-width: 1800px) {
    margin-top: 3px;
  }
  @media only screen and (max-width: 1600px) {
    margin-top: 8px;
  }
}
.custom-height {
  height: 40px;
  width: 6rem;
  img {
    height: 1rem;
    width: 1rem;
  }
  span {
    line-height: 20px;
  }
}
.previous-invite {
  max-width: 700px !important;
  outline: 3px solid #254858;
  padding: 5px !important;
  border-radius: 12px;
  left: 400px !important;
}
.height {
  &-upper {
    height: 70%;
    @media only screen and (max-width: 1920px) {
      height: 75%;
    }
  }
  &-lower {
    cursor: pointer;
    display: flex;
    margin-left: 20px;
    height: 30%;
    align-items: center;
    @media only screen and (max-width: 1920px) {
      height: 25%;
    }
  }
}
.m-left {
  margin-left: 6px;
}
.margin-top-diss {
  margin-top: 10px;
}
.margin-bot-head {
  margin-bottom: 4px;
}
.icon-padding {
  margin-left: 5px;
  &-counterpart {
    margin-left: 10px;
  }
}
.sub-card {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.display {
  &-large {
    margin-left: 5px;
    float: right;
    @media only screen and (max-width: 1820px) {
      display: none;
    }
  }
  &-normal {
    margin-left: 5px;
    @media only screen and (min-width: 1820px) {
      display: none;
    }
  }
}
.width-max-details {
  max-width: 800px !important;
  right: 1px !important;
  top: 45px !important;
  outline: 3px solid #254858;
  padding: 5px !important;
  max-height: 615px;
  border-radius: 12px;
}
.documnet-details-heading {
  padding-right: 15px;
}
.arrow-btn-color {
  background-color: #e2e2e2 !important;
}
.head-details-title-container {
  display: flex;
  align-self: center;
  border: 2px solid #e2e2e2;
  border-radius: 12px;
  font-size: $global-large-font-size;
  margin-left: 4px;
  @media only screen and (max-width: 1600px) {
    font-size: $global-font-size;
  }
}
.main-contain-challenge-url {
  border-top: 1px solid #e5e5e5;
}
.challenge-url-details {
  margin: 10px;
}
.bottom-table {
  margin-bottom: 5px;
}
.ellipsis-challenge-link {
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  width: 75%;
  @media only screen and (max-width: 1900px) {
    width: 70%;
  }
  @media only screen and (max-width: 1800px) {
    width: 66%;
  }
  @media only screen and (max-width: 1700px) {
    width: 60%;
  }
}
.link-btn-top {
  pointer-events: none;
  opacity: 0.7;
}

.public-padding-side {
  padding: 0 13px;
}
.challenge-label-width {
  width: 52.3% !important;
  @media only screen and (max-width: 2150px) {
    width: 52.4% !important;
  }
  @media only screen and (max-width: 2100px) {
    width: 52.5% !important;
  }
  @media only screen and (max-width: 1900px) {
    width: 52.6% !important;
  }
  @media only screen and (max-width: 1700px) {
    width: 53% !important;
  }
}
.public-label-width {
  width: 52.3% !important;
  @media only screen and (max-width: 2150px) {
    width: 52.4% !important;
  }
  @media only screen and (max-width: 2100px) {
    width: 52.5% !important;
  }
  @media only screen and (max-width: 1900px) {
    width: 52.6% !important;
  }
  @media only screen and (max-width: 1700px) {
    width: 54% !important;
  }
}
.public-label-width-opp {
  width: 53.3% !important;
  @media only screen and (max-width: 2150px) {
    width: 53.4% !important;
  }
  @media only screen and (max-width: 2100px) {
    width: 53.5% !important;
  }
  @media only screen and (max-width: 1900px) {
    width: 53.6% !important;
  }
  @media only screen and (max-width: 1700px) {
    width: 55% !important;
  }
}
.private-label-width {
  width: 72.6% !important;
  @media only screen and (max-width: 2150px) {
    width: 72.9% !important;
  }
  @media only screen and (max-width: 2100px) {
    width: 73.1% !important;
  }
  @media only screen and (max-width: 1900px) {
    width: 73.9% !important;
  }
  @media only screen and (max-width: 1700px) {
    width: 74% !important;
  }
}
.challenge-url-margin-copy-icon {
  margin-right: 11.8% !important;
  @media only screen and (max-width: 2100px) {
    margin-right: 10.5% !important;
  }
  @media only screen and (max-width: 1900px) {
    margin-right: 9% !important;
  }
  @media only screen and (max-width: 1700px) {
    margin-right: 8% !important;
  }
}
.public-url-margin-copy-icon {
  margin-right: 11% !important;
  @media only screen and (max-width: 2100px) {
    margin-right: 10% !important;
  }
  @media only screen and (max-width: 1900px) {
    margin-right: 9.5% !important;
  }
  @media only screen and (max-width: 1700px) {
    margin-right: 8% !important;
  }
}
</style>
